import { CashRequestDetail } from "@/pages/requests/cash/schema/cash-requests.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { RequestStatusBadge } from "../badge/RequestStatusBadge";
import { CashRequestStatus } from "@/constants/entity-status";

interface Props {
  request?: CashRequestDetail | null;
}

export const CashRequestMainDataCard = ({ request }: Props) => {
  return (
    <Flex
      flexDir="column"
      padding="12px"
      height="100%"
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      borderRadius="12px"
    >
      <Text
        className="amd-card-title"
        paddingBottom="16px"
        textTransform={"uppercase"}
        paddingX="24px"
      >
        Datos de la solicitud
      </Text>
      <Grid templateColumns="repeat(2, 1fr)">
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-title-label">Fecha de solicitud:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-value-label">
            {dayjs(request?.fechaSolicitud).format("DD/MM/YYYY")}
          </Text>
        </GridItem>
        {request?.fechaEjecucion && (
          <>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Fecha de retiro:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">
                {dayjs(request.fechaEjecucion).format("DD/MM/YYYY")}
              </Text>
            </GridItem>
          </>
        )}
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-title-label">Cuenta origen:</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-value-label">{request?.cuentaOrigen}</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-title-label">Sucursal:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-value-label">{request?.sucursal}</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-title-label">Solicitante:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-value-label">{request?.solicitante}</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-title-label">Estado:</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-value-label">
            <RequestStatusBadge status={request?.estado as CashRequestStatus} />
          </Text>
        </GridItem>
      </Grid>
    </Flex>
  );
};
